import Vue from 'vue'
import Router from 'vue-router'
import $store from "../store"

import Login from '../pages/Login.vue';
import Home from '../pages/Home.vue';
import Info from '../pages/Info.vue';

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Login',
            meta:{
                title:'登录',
            },
            component: Login
        },
        {
            path: '/home',
            name: 'Home',
            meta:{
                title:'首页',
            },
            component: Home
        },
        {
            path: '/info/:id/:type',
            name: 'Info',
            meta:{
                title:'数据列表',
            },
            component: Info
        }
    ]
});



router.beforeEach((to, form, next) => {

    let { title } = to.meta;
    // console
    document.title = title || '';


    $store.commit("SET",{
        menu: (to.path == '/') ? false : true
    });

    next();
});




export default router;



// WEBPACK FOOTER //
// ./src/router/index.js